import { render, staticRenderFns } from "./FotosVideos.vue?vue&type=template&id=7c6d1d04&scoped=true&"
import script from "./FotosVideos.vue?vue&type=script&lang=js&"
export * from "./FotosVideos.vue?vue&type=script&lang=js&"
import style0 from "./FotosVideos.vue?vue&type=style&index=0&id=7c6d1d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6d1d04",
  null
  
)

export default component.exports